// @file composer_modal pinia store
import type { DockableModalState } from '@@/types'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useComposerModalStore = defineStore('composerModal', () => {
  /* ---------------------- */
  /* STATE                  */
  /* ---------------------- */

  // Currently used to collapse post composer in submission request view (to show surface header)
  const isExpandedMobile = ref(true)
  const modalState = ref<DockableModalState>('docked')
  const scrolledToTop = ref<boolean>(false)
  const scrolledToBottom = ref<boolean>(false)
  const shouldFocusAttachmentCaption = ref<boolean>(false)
  const xRequiresApprovalBanner = ref<boolean>(false)

  /* ---------------------- */
  /* GETTERS                */
  /* ---------------------- */

  const isDocked = computed<boolean>(() => modalState.value === 'docked')
  const isExpanded = computed<boolean>(() => modalState.value === 'expanded')

  /* ---------------------- */
  /* ACTIONS                */
  /* ---------------------- */

  const expandMobile = (): void => {
    isExpandedMobile.value = true
  }

  const collapseMobile = (): void => {
    isExpandedMobile.value = false
  }

  const dockComposerModal = (): void => {
    modalState.value = 'docked'
  }

  const expandComposerModal = (): void => {
    modalState.value = 'expanded'
  }

  const updateScrollPosition = ({ scrolledToTop: newScrolledToTop, scrolledToBottom: newScrolledToBottom }): void => {
    scrolledToTop.value = newScrolledToTop
    scrolledToBottom.value = newScrolledToBottom
  }

  const setShouldFocusAttachmentCaption = (): void => {
    shouldFocusAttachmentCaption.value = true
  }

  const clearShouldFocusAttachmentCaption = (): void => {
    shouldFocusAttachmentCaption.value = false
  }

  const showRequiresApprovalBanner = (): void => {
    xRequiresApprovalBanner.value = true
  }

  const hideRequiresApprovalBanner = (): void => {
    xRequiresApprovalBanner.value = false
  }

  return {
    // Getters
    isExpandedMobile,
    modalState,
    scrolledToTop,
    scrolledToBottom,
    shouldFocusAttachmentCaption,
    xRequiresApprovalBanner,
    isDocked,
    isExpanded,

    // Actions
    expandMobile,
    collapseMobile,
    expandComposerModal,
    dockComposerModal,
    updateScrollPosition,
    setShouldFocusAttachmentCaption,
    clearShouldFocusAttachmentCaption,
    showRequiresApprovalBanner,
    hideRequiresApprovalBanner,
  }
})
